export const useIsAppInCypress = ()=>{
    var _window;
    return !!((_window = window) === null || _window === void 0 ? void 0 : _window.Cypress) || window.location.host.includes('.orbits.run');
};
